export default __webpack_public_path__ + "static/about-kalbio-2-a2535595ccd37b85540c5c12945279ac.webp";